// extracted by mini-css-extract-plugin
module.exports = {"memberCol":"UserListPermission_memberCol_3qHxI"};